import React from 'react';
import ForgetPasswordForm from 'components/authentication/ForgetPasswordForm';

const ForgetPassword = () => {
  return (
    <div className="text-center">
      <h5 className="mb-0"> Mot de passe oublié?</h5>
      <small>Entrez votre email et nous vous enverrons un lien de réinitialisation.</small>
      <ForgetPasswordForm />
    </div>
  );
};

export default ForgetPassword;
